module.exports = __webpack_public_path__ + "static/media/product3.60af8379.jpg";